export default __webpack_public_path__ + "static/media/user.7b816e72.svg";